/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Limits_Storage_AddonsInputs */



/**
* | output |
* | --- |
* | "Storage add-ons" |
*
* @param {Compare_Limits_Storage_AddonsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compare_limits_storage_addons = /** @type {((inputs?: Compare_Limits_Storage_AddonsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Limits_Storage_AddonsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicher-Zusatzpakete")
	return /** @type {LocalizedString} */ ("Storage add-ons")
});